export default __webpack_public_path__ + "static/media/26.27f8b28b.jpg";